import domReady from '@wordpress/dom-ready';

domReady(() => {
  const findstr = window.findstr || {};

  findstr.hooks.addFilter('urlManagementDisabled', 'disabledUrl', () => {
    return true;
  });

  findstr.hooks.addFilter('findstrQueryMinLength', 'minLengthSearch', () => {
    return 0;
  });

  findstr.hooks.addFilter(
    'findstrCheckboxFieldChoices',
    'alphabetical-filter',
    function (choices, field) {
      // Check if this is the alphabetical filter field
      if (
        field.id === 'alphabetical-filter' ||
        field.source_name === 'store_name_first_character'
      ) {
        const alphabetChoices = {};

        // Generate A-Z letters
        for (let i = 65; i <= 90; i++) {
          const letter = String.fromCharCode(i);

          alphabetChoices[letter] = {
            value: letter,
            label: letter,
          };
        }

        return alphabetChoices;
      }

      return choices;
    }
  );
});
